import * as React from 'react';
import { ConfirmModal, ConfirmPasswordModal, TemplateModal, LoginRegistrationModal, UpdateProfileModal, OnlineCheckoutModal, PasswordResetModal, PasswordResetConfirmModal, OfferRequestThanksModal, DeleteEmployeeModal, ConfirmCarDeleteModal, ConfirmAccountDeleteModal, ConfirmDeliveryAddressDeleteModal, QualityRestrictionModal, CredentialsModal, DealerAddressModal, DealerImprintModal, DealerTermCondModal, ImagesCompareModal, VehicleDetailedSliderModal, PriceReviewModal, RateSearchWidgetModal, DetailsModal, OfferModal, Congratulations, OrderOverviewTermsModal, DeliveryAddressesModal, DeliveryAddressesAddModal, SellerCheckoutModal } from '../../components/modals';
import FaqModal from '../../components/modals/FinancingModal/FaqModal';
const ModalsFactory = {
    CONFIRM_MODAL: (props) => {
        return (React.createElement(ConfirmModal, { ...props }));
    },
    ONLINE_CHECKOUT_MODAL: (props) => {
        return (React.createElement(OnlineCheckoutModal, { ...props }));
    },
    CONGRATULATIONS_CHECKOUT_MODAL: (props) => {
        return (React.createElement(Congratulations, { ...props }));
    },
    CONFIRM_PASSWORD_MODAL: (props) => {
        return (React.createElement(ConfirmPasswordModal, { ...props }));
    },
    TEMPLATE_MODAL: (props) => {
        return (React.createElement(TemplateModal, { ...props }));
    },
    DELETE_DEALER_EMPLOYEE_MODAL: (props) => {
        return (React.createElement(DeleteEmployeeModal, { ...props }));
    },
    LOGIN_REGISTRATION_MODAL: (props) => {
        return (React.createElement(LoginRegistrationModal, { ...props }));
    },
    UPDATE_PROFILE_MODAL: (props) => {
        return (React.createElement(UpdateProfileModal, { ...props }));
    },
    PASSWORD_RESET_MODAL: (props) => {
        return (React.createElement(PasswordResetModal, { ...props }));
    },
    PASSWORD_RESET_CONFIRM_MODAL: (props) => {
        return (React.createElement(PasswordResetConfirmModal, { ...props }));
    },
    OFFER_REQUEST_THANKS_MODAL: (props) => {
        return (React.createElement(OfferRequestThanksModal, { ...props }));
    },
    CONFIRM_CAR_DELETE_MODAL: (props) => {
        return (React.createElement(ConfirmCarDeleteModal, { ...props }));
    },
    CONFIRM_ACCOUNT_DELETE_MODAL: (props) => {
        return (React.createElement(ConfirmAccountDeleteModal, { ...props }));
    },
    CONFIRM_DELIVERY_ADDRESS_DELETE_MODAL: (props) => {
        return (React.createElement(ConfirmDeliveryAddressDeleteModal, { ...props }));
    },
    DELIVERY_ADDRESSES_MODAL: (props) => {
        return (React.createElement(DeliveryAddressesModal, { ...props }));
    },
    OFFER_MODAL: (props) => {
        return (React.createElement(OfferModal, { ...props }));
    },
    FAQ_MODAL: (props) => {
        return (React.createElement(FaqModal, { ...props }));
    },
    DETAILS_MODAL: (props) => {
        return (React.createElement(DetailsModal, { ...props }));
    },
    SELLER_CHECKOUT_MODAL: (props) => {
        return (React.createElement(SellerCheckoutModal, { ...props }));
    },
    ORDER_OVERVIEW_TERMS_MODAL: (props) => {
        return (React.createElement(OrderOverviewTermsModal, { ...props }));
    },
    QUALITY_RESTRICTION_MODAL: (props) => {
        return (React.createElement(QualityRestrictionModal, { ...props }));
    },
    CREDENTIALS_MODAL: (props) => {
        return (React.createElement(CredentialsModal, { ...props }));
    },
    DELIVERY_ADDRESSES_ADD_MODAL: (props) => {
        return (React.createElement(DeliveryAddressesAddModal, { ...props }));
    },
    DEALER_ADDRESS_MODAL: (props) => {
        return (React.createElement(DealerAddressModal, { ...props }));
    },
    DEALER_IMPRINT_MODAL: (props) => {
        return (React.createElement(DealerImprintModal, { ...props }));
    },
    DEALER_TERM_COND_MODAL: (props) => {
        return (React.createElement(DealerTermCondModal, { ...props }));
    },
    IMAGES_COMPARE_MODAL: (props) => {
        return (React.createElement(ImagesCompareModal, { ...props }));
    },
    VEHICLE_DETAILED_SLIDER_MODAL: (props) => {
        return (React.createElement(VehicleDetailedSliderModal, { ...props }));
    },
    PRICE_REVIEW_MODAL: (props) => {
        return (React.createElement(PriceReviewModal, { ...props }));
    },
    RATE_SEARCH_WIDGET_MODAL: (props) => {
        return (React.createElement(RateSearchWidgetModal, { ...props }));
    }
};
export default ModalsFactory;
